module.exports = __webpack_public_path__ + "img/sol_isol_pain3.2c66328e.png";